import { defineComponent as n, computed as o, openBlock as c, createElementBlock as a, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "b61eaa89-c596-4ba1-ac9c-a29f635da463" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#b61eaa89-c596-4ba1-ac9c-a29f635da463)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h512v256l-256 32L0 256Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M0 256h512v256H0Z"
}, null, -1), g = /* @__PURE__ */ e("circle", {
  cx: "256",
  cy: "256",
  r: "128",
  fill: "#d80027"
}, null, -1), x = { fill: "none" }, w = ["r"], N = /* @__PURE__ */ n({
  __name: "in-mz",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const t = i, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (c(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (c(), a("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=in-mz-f2d7cb21.js.map
